<div class="flex flex-wrap gap-2">
  <div
    [ngClass]="{ 'pointer-events-none opacity-30': disabled() }"
    (click)="goBack()"
    class="w-6 h-6 bg-neutral-600 flex justify-center items-center rounded cursor-pointer"
    tabindex="1"
  >
    <flx-icon name="arrow-left" />
  </div>

  @for (crumb of breadcrumbs(); track crumb) {
    <div class="h-6 px-2 text-xs bg-neutral-600 flex flex-none justify-center items-center rounded">
      <flx-icon
        name="stars-flowx-yellow"
        class="mr-1"
      />
      <ng-container *ngIf="hasPrefix(crumb)">
        <span class="text-yellow-500 font-bold mr-1">AI</span>
        <span class="text-neutral-100 mr-1">-</span>
      </ng-container>
      <span class="text-neutral-100">{{ segmentLabel[crumb] ?? '' }}</span>
    </div>
  }
</div>
